<div class="sidebar h-100" [ngClass]="{'open' : openSidebarFlag}">
  <div class="body">
    <ng-container>
      <div class="menu">

        <!-- <mat-icon class="menu-icon" [hidden]="openSidebarFlag" (click)="openSidebar()" style="color:#fff;"
          [ngClass]="{'disableTableRow' : (disableSidebar) }">menu</mat-icon> -->
        <app-platform-icon class="d-inline-block align-middle menu-icon" [platform]="selectedApp.os" [iconSize]="'20px'"
          (click)="toggleAppSelector()"></app-platform-icon>

        <app-selector [hidden]="!openSidebarFlag" style="width: 176px; position: absolute; top: 1.5%; left: 100%;">
        </app-selector>

        <ul>
          <ng-container *ngFor="let item of menuList; index as i">
            <li appDisableFeature [callbackFromDirective]="handleCallbackClickListener"
              [pathString]="item.parentFeature + '.' + item.featureName" (click)="changeRoute(i, item.alias)"
              [ngClass]="{'disableTableRow' : (disbaleMenuListNav || disableSidebar), 'active': item.isActive, 'seperator': item.seperator}"
              *ngIf="!item.shouldBeHidden">
              <a class="cursor-pointer">
                <span *ngIf="item.icon.type == 'custom'" class="sb-icon custom align-middle">
                  <svg-icon-sprite [src]="item.icon.src" [width]="'20px'"></svg-icon-sprite>
                </span>
                <span *ngIf="item.icon.type == 'material'" class="sb-icon material align-middle">
                  <i class="material-icons" [ngClass]="item.icon.class">{{item.icon.name}}</i>
                </span>
                <span class="title align-middle ml-4" [ngClass]="{'active': item.isActive}">
                  {{item.title}}
                </span>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-container>

    <div class="footer">
      <!-- <div class="copyright">
        {{currentYear}} Copyright
      </div> -->
      <div class="links mt-2">
        <span class="d-inline-block align-middle " style="margin-left:27px;" *ngIf="plan !== 'user_onboarding'"
          [ngClass]="{'disableTableRow' : (disableSidebar) }">
          <a href="https://cedocs.netcorecloud.com/docs/setup-nudges" target="_blank"><i
              class="material-icons">help_outline</i></a>
        </span>
        <!-- <span class="d-inline-block align-middle " style="margin-left:27px;" *ngIf="plan && plan === 'user_onboarding'"
          [ngClass]="{'disableTableRow' : (disableSidebar) }">
          <a href="https://docs.hansel.io/v3.0/docs" target="_blank"><i class="material-icons">help_outline</i></a>
        </span> -->
      </div>
    </div>
  </div>
</div>
